export default "__VITE_ASSET__C_rOL7uY__"